import { INTAKE_TYPES } from './enums';

const TNVR_INTAKE_TYPES = [
  INTAKE_TYPES.STRAY,
  INTAKE_TYPES.OWNER_SURRENDER,
  INTAKE_TYPES.OWNER_REQUESTED_EUTHANASIA,
  INTAKE_TYPES.CLINIC_IN,
  INTAKE_TYPES.SERVICE_IN,
  INTAKE_TYPES.DOA,
  INTAKE_TYPES.TNVR,
];

// NOTE :: Seized ("Field Services Admission") and Return were on the CS Intake button before the case list
// existed. Keep them, or CS staff lose two intakes they already use.
const COMMUNITY_SUPPORT_INTAKE_TYPES = [
  INTAKE_TYPES.STRAY,
  INTAKE_TYPES.SEIZED,
  INTAKE_TYPES.OWNER_SURRENDER,
  INTAKE_TYPES.RETURN,
  INTAKE_TYPES.OWNER_REQUESTED_EUTHANASIA,
  INTAKE_TYPES.CLINIC_IN,
  INTAKE_TYPES.SERVICE_IN,
  INTAKE_TYPES.BOARDING_IN,
];

const FIELD_SERVICES_INTAKE_TYPES = [
  INTAKE_TYPES.STRAY,
  INTAKE_TYPES.SEIZED,
  INTAKE_TYPES.OWNER_SURRENDER,
  INTAKE_TYPES.OWNER_REQUESTED_EUTHANASIA,
  INTAKE_TYPES.DOA,
];

// NOTE :: FS always offered Stray and Seized, even when the shelter turned the form off. Keep them
// on, or officers lose the two intakes they use most. The picker falls back to a fixed label for these.
const FIELD_SERVICES_ALWAYS_ON_INTAKE_TYPES = [INTAKE_TYPES.STRAY, INTAKE_TYPES.SEIZED];

export {
  COMMUNITY_SUPPORT_INTAKE_TYPES,
  FIELD_SERVICES_ALWAYS_ON_INTAKE_TYPES,
  FIELD_SERVICES_INTAKE_TYPES,
  TNVR_INTAKE_TYPES,
};
